import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Grid, Input, InputLabel, styled, useTheme, } from "@mui/material";
import { useState } from "react";
import { usePortalFramework } from "../../PortalFramework";
import { useParams } from "react-router-dom";
import { post } from "@sal/webrequest-web";
const StyledInput = styled(Input)(({ theme }) => ({
    color: "inherit",
    "&:not(.Mui-disabled):hover::before": {
        borderColor: "inherit",
    },
    "&:not(.Mui-disabled):before": {
        borderColor: "inherit",
    },
    "&:not(.Mui-disabled):after": {
        borderColor: "inherit",
    },
}));
export function ResetPasswordForm({ inputLabelStyles, }) {
    //const auth = useAuth();
    const portalFramework = usePortalFramework();
    const theme = useTheme();
    const { passwordResetToken } = useParams();
    // #region PROPERTIES
    const [getNewPassword, setNewPassword] = useState("");
    const [getConfirmNewPassword, setConfirmNewPassword] = useState("");
    const [getMessage, setMessage] = useState("");
    //#endregion
    // #region EVENT HANDLERS
    const onChange = (setter) => (event) => {
        setMessage("");
        setter(event.target.value);
    };
    const form_onsubmit = (e) => {
        e.preventDefault();
        if (validateControls()) {
            post("PortalFramework/Account/ResetPassword", {
                passwordResetToken: passwordResetToken,
                newPassword: getNewPassword,
            }).then((response) => {
                console.log("Response: %o", response);
                resetPassword_callback();
            });
        }
    };
    const resetPassword_callback = () => {
        window.location.hash = "Login";
    };
    const validateControls = () => {
        if (getNewPassword.length === 0) {
            setMessage("Please enter new password.");
            return false;
        }
        if (getConfirmNewPassword.length === 0) {
            setMessage("Please enter confirm password.");
            return false;
        }
        if (getNewPassword !== getConfirmNewPassword) {
            setMessage("Password and confirm password does not match.");
            return false;
        }
        return true;
    };
    //#endregion
    return (_jsx("form", { onSubmit: form_onsubmit, children: _jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", spacing: 4, children: [_jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, direction: "column", justifyContent: "space-evenly", children: [_jsx(Grid, { item: true, children: _jsx(InputLabel, { htmlFor: "txtNewPassword", style: Object.assign({}, inputLabelStyles), children: "New Password" }) }), _jsx(Grid, { item: true, children: _jsx(StyledInput, { fullWidth: true, type: "password", id: "txtNewPassword", name: "newPassword", value: getNewPassword, placeholder: "Enter new password", autoComplete: "off", autoCorrect: "off", autoFocus: true, spellCheck: "false", onChange: onChange(setNewPassword) }) })] }) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, direction: "column", justifyContent: "space-evenly", children: [_jsx(Grid, { item: true, children: _jsx(InputLabel, { htmlFor: "txtConfirmNewPassword", style: Object.assign({}, inputLabelStyles), children: "Confirm new password" }) }), _jsx(Grid, { item: true, children: _jsx(StyledInput, { fullWidth: true, name: "txtConfirmNewPassword", id: "txtConfirmNewPassword", type: "password", value: getConfirmNewPassword, placeholder: "Confirm password", autoComplete: "off", autoCorrect: "off", spellCheck: "false", onChange: onChange(setConfirmNewPassword) }) })] }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", color: "primary", size: "large", children: "Reset Password" }) }), _jsx(Grid, { item: true, xs: 12, children: getMessage ? _jsx(Alert, { severity: "error", children: getMessage }) : null })] }) }));
}
